export default "__VITE_ASSET__DLVIDU8___"